import React, { useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";

interface NoticeData {
  heading: string;
  notice: string;
  slug: string;
  date_of_notice: string;
  banner_url: string;
}
interface Notice {
  success: boolean;
  message: string;
  statusCode: number;
  data: NoticeData[];
}

const NoticeCircular = () => {
  const [selectedNotice, setSelectedNotice] = useState<NoticeData | null>(null);

  const {
    data: noticeResponse,
    loading: noticeLoading,
    error: noticeError,
  } = useApi<Notice>("/api/notices", {
    method: "GET",
    autoCall: true,
  });

  const convertDate = (noticedate: string): string => {
    const dateObj = new Date(noticedate);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "long" });
    const year = dateObj.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // const decodeHtml = (html: string): string => {
  //   const doc = new DOMParser().parseFromString(html, "text/html");
  //   return doc.documentElement.textContent || "";
  // };

  function decodeHtml(html: string): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  return (
    <>
      <Loader loading={noticeLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Notice Circulars </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Communication & Culture</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Notice Circulars
                  </li>
                </ol>
              </nav>
            </div>

            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Notice and Circulars </h5>
              </div>
            </div>
          </div> */}
          {/* Candidates Grid */}
          <div className="row">
            {noticeResponse?.data.map((item, idx) => (
              <div className="col-lg-4 col-sm-6 mt-1 mb-2" key={idx}>
                <div className="card h-100 w-100">
                  <div className="card-body d-flex flex-column justify-content-between">
                    <div>
                      <div className="">
                        <div className="">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-column gap-2  mb-1">
                              <h6 className="fs-16 fw-semibold me-1 text-wrap"
                                style={{ color: "#2e3294" }}
                              >
                                {item.heading}
                              </h6>
                              <p className="text-gray fs-13 fw-normal">
                                {convertDate(item?.date_of_notice)}
                              </p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Align this section to bottom */}
                    <div className="">
                      <div className="rounded py-1 d-flex justify-content-start align-items-center">
                        <Link
                          to="#"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#notice_banner"
                          onClick={() => setSelectedNotice(item)}
                          className="text-decoration-none"
                        >
                          <span
                            className="btn btn-sm"
                            style={{
                              backgroundColor: "#2e3294",
                              color: "#fff",
                              border: "none",
                            }}
                          >
                            View
                          </span>
                        </Link>
                        {/* 
                        <Link
                          to="#"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#notice_banner"
                          onClick={() => setSelectedNotice(item)}
                          className="text-decoration-none"
                        >
                          <span
                            className="fs-15 fw-medium badge d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: "#F26522" }}
                          >
                            <i className="bi bi-eye"></i>
                          </span>
                        </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* /Candidates Grid */}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      {/* Attendance Cut Off Rules --------------- */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="notice_banner"
      >
        <div className="offcanvas-header border-bottom">
          <h4 className="d-flex align-items-center">
            {selectedNotice?.heading}
            <span className="badge bg-primary-transparent fw-medium ms-2">
              {selectedNotice?.date_of_notice
                ? convertDate(selectedNotice.date_of_notice)
                : ""}
            </span>
          </h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        {/* <div className="offcanvas-body">
          <div className="card ">
            <img src={selectedNotice?.banner_url || "vikas kumar"} alt="Notice Banner" />
          </div>
        </div> */}
        <div className="offcanvas-body">
          <div className="card p-3">
            <div
              className="rendered-html notice-content"
              // dangerouslySetInnerHTML={{
              //   __html: selectedNotice?.notice
              //     ? decodeHtml(selectedNotice.notice)
              //     : "",
              // }}

              dangerouslySetInnerHTML={{
                __html: selectedNotice?.notice
                  ? decodeHtml(selectedNotice.notice)
                  : "",
              }}

            // dangerouslySetInnerHTML={{
            //   __html: selectedNotice?.notice
            //     ? decodeHtml("&lt;p&gt;&lt;img src=&quot;https://team1consulting.com/weconnect/uploads/da4fb5c6e93e74d3df8527599fa62642.png&quot; style=&quot;width: 632.005px;&quot;&gt;&lt;br&gt;&lt;ul&gt;  &lt;li&gt;Item 1&lt;/li&gt;  &lt;li&gt;Item 2&lt;/li&gt;  &lt;li&gt;Item 3&lt;/li&gt;&lt;/ul&gt;&lt;/p&gt;")
            //     : "",
            // }}
            />
          </div>
        </div>
      </div>
      {/* A Noble Start to the New Year --------------- */}
    </>
  );
};

export default NoticeCircular;
